import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import SelectSearchParty from "../AdminSearchExpense/SelectSearchParty";
import { Button, Table, Form, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";

const AdmAttendanceEntry = () => {
  const [expenseNo, setExpenseNo] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dateRef = useRef(null);
  const [partyId, setPartyId] = useState("");
  const [partyName, setPartyName] = useState("");
  const [partyReference, setPartyReference] = useState("");
  const [balPay, setBalPay] = useState("");
  const [paidPay, setPaidPay] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [rows, setRows] = useState([
    { id: 1, category: "", amount: "0.00", remarks: "" },
  ]);
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(true);
  const [loadingAccounts, setLoadingAccounts] = useState(false);
  const [errorBanks, setErrorBanks] = useState("");
  const [errorAccounts, setErrorAccounts] = useState("");
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [cashAmount, setCashAmount] = useState(0);
  const [bankAmount, setBankAmount] = useState(0);
  const [selectedAccount, setSelectedAccount] = useState("");
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");

  useEffect(() => {
    if (location.state?.expenseData) {
      const expenseData = location.state.expenseData;
      console.log("Received expenseData:", expenseData);

      //  Set party details
      setPartyId(expenseData.party_id || "");
      setPartyName(expenseData.party_name || "");
      setPartyReference(expenseData.party_reference || "");

      //  Set payment details
      setExpenseNo(expenseData.expense_no || "");
      setBalPay(expenseData.balance_amount || "");
      setPaidPay(expenseData.paid_amount || "");
      setSelectedDate(
        expenseData.date || new Date().toISOString().split("T")[0]
      );
      setTotalAmount(expenseData.total_amount || 0);

      //  Map expense details
      if (Array.isArray(expenseData.ExpenseDetailsdata)) {
        setRows(
          expenseData.ExpenseDetailsdata.map((detail) => ({
            id: detail.expense_detail_id || Date.now(),
            category: detail.expense_categoryId || null,
            category_name: detail.expense_category_name || "",
            amount: detail.amount || "",
            remarks: detail.remarks || "",
          }))
        );
      } else {
        setRows([
          {
            id: Date.now(),
            category: null,
            category_name: "",
            amount: "",
            remarks: "",
          },
        ]);
      }

      //  Fetch payment details directly
      if (
        Array.isArray(expenseData.PaymentDetailsData) &&
        expenseData.PaymentDetailsData.length > 0
      ) {
        const cashPayment = expenseData.PaymentDetailsData.find(
          (payment) => payment.payment_method === "Cash"
        );
        const bankPayment = expenseData.PaymentDetailsData.find(
          (payment) => payment.payment_method === "Bank"
        );

        //  Set values for cash and bank directly
        setCashAmount(cashPayment ? cashPayment.applied_amount : "");
        setSelectedBank(bankPayment ? bankPayment.bankId : "");
        setSelectedAccount(bankPayment ? bankPayment.bank_account : "");
        setBankAmount(bankPayment ? bankPayment.applied_amount : "");
      }
    }
  }, [location.state]);

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    if (field === "amount") {
      const newTotalAmount = updatedRows.reduce(
        (acc, row) => acc + parseFloat(row.amount || 0),
        0
      );
      setTotalAmount(newTotalAmount);
      setCashAmount(newTotalAmount.toFixed(2));
    }

    setRows(updatedRows);
  };
  // Fetch Bank List on Component Mount
  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}BANK/GetAllbankList/`);
        const result = await response.json();

        if (response.ok && result.data) {
          setBankList(result.data);
        } else {
          throw new Error("Failed to fetch bank list");
        }
      } catch (err) {
        setErrorBanks("Error fetching banks");
      } finally {
        setLoadingBanks(false);
      }
    };
    fetchBanks();
  }, []);
  // Fetch Account Details When a Bank is Selected
  const fetchAccountDetails = async (bankId) => {
    if (!bankId) return;
    setLoadingAccounts(true);
    setErrorAccounts(""); // Reset error message

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Account_Details/GetAccountDetailsBasedOnBankId/${bankId}`
      );
      const result = await response.json();

      if (response.ok) {
        if (result.message === "No record found!!") {
          setAccountList([]);
          setErrorAccounts("No accounts found for this bank.");
        } else if (result.data) {
          setAccountList(result.data);
        }
      } else {
        throw new Error("Failed to fetch account details.");
      }
    } catch (err) {
      setErrorAccounts("Error fetching account details");
      setAccountList([]);
    } finally {
      setLoadingAccounts(false);
    }
  };
  const handleBankAmountChange = (e) => {
    const bankVal = e.target.value || 0;
    setBankAmount(bankVal);
  };
  // Fetch expense categories
  useEffect(() => {
    const fetchExpenseCategory = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}EXPENSE/EXPENSE_INCOME/ListBasedOnCategory/?org_id=${orgId}&branch_id=${branchId}&flag=E`
        );
        const data = await response.json();
        if (data.message === "success" && Array.isArray(data.data)) {
          setExpenseCategory(data.data);
        }
      } catch (error) {
        console.error("Error fetching expense categories:", error);
      }
    };
    fetchExpenseCategory();
  }, []);

  const handleClose = () => {
    navigate("/admin/search-expense");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                ADD EXPENSE
              </p>
              <div className="row mb-3-mt-3">
                <div
                  className="col-12"
                  d-flex
                  flex-wrap
                  gap-2
                  // style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    disabled
                    // onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    disabled
                    // onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row p-2">
                <span style={{ fontWeight: 700 }}>Expense Header</span>
                <div
                  className="col-12"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="select-party" className="form-label">
                          Select Party<span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="select-party"
                            className="form-control details"
                            value={partyName}
                            placeholder="Enter select-party"
                            disabled
                          />
                          {/* <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                          >
                            ...
                          </button> */}
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="date" className="form-label">
                          Date <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          id="date"
                          className="form-control details"
                          ref={dateRef}
                          max={new Date().toISOString().split("T")[0]}
                          value={selectedDate}
                          onChange={(e) => setSelectedDate(e.target.value)}
                          disabled
                        />
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="expense-no" className="form-label">
                          Expense No.
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="expense-no"
                            className="form-control details"
                            value={expenseNo}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="party-reference" className="form-label">
                          Party Reference{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="party-reference"
                            className="form-control details"
                            value={partyReference}
                            onChange={(e) => setPartyReference(e.target.value)}
                            placeholder="Enter party reference"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="total-amount" className="form-label">
                          Total Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="total-amount"
                            className="form-control details"
                            placeholder="0.00"
                            value={totalAmount.toFixed(2)}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="paid-amount" className="form-label">
                          Paid Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="paid-amount"
                            className="form-control details"
                            value={paidPay}
                            placeholder="0.00"
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-12 col-md-3 mb-0">
                        <label htmlFor="balance-amount" className="form-label">
                          Balance Amount
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="balance-amount"
                            className="form-control details"
                            value={balPay}
                            placeholder="0.00"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div
                  className="col-12"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  <div className="mt-2">
                    <h3 style={{ color: "black" }}>Expense Detail</h3>
                    <Table bordered hover disabled>
                      <thead className="thead-dark">
                        <tr>
                          <th>Sr.No</th>
                          <th>Expense Category</th>
                          <th>Amount</th>
                          <th>Remarks</th>
                          <th>Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <Form.Control
                                as="select"
                                className="form-select"
                                value={row.category}
                                onChange={(e) =>
                                  handleInputChange(
                                    index,
                                    "category",
                                    e.target.value
                                  )
                                }
                                disabled
                              >
                                <option value="">Select</option>
                                {expenseCategory.map((category) => (
                                  <option
                                    key={category.expense_category_id}
                                    value={category.expense_category_id}
                                  >
                                    {category.expense_category}
                                  </option>
                                ))}
                              </Form.Control>
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                value={row.amount}
                                // onChange={(e) => handleInputChange(index, "amount", e.target.value)}
                                disabled
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                value={row.remarks}
                                // onChange={(e) => handleInputChange(index, "remarks", e.target.value) }
                                disabled
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>

              <div className="row">
                <div
                  className="col-12 p-2"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                >
                  {/* Cash Input Field */}
                  <Row className="align-items-center mb-2">
                    <Col xs={2}>
                      <strong>CASH</strong>
                    </Col>
                    <Col xs={4}>
                      <Form.Control
                        type="text"
                        value={cashAmount}
                        // onChange={handleCashChange}
                        disabled
                      />
                    </Col>
                  </Row>
                  {/* Bank Selection */}
                  <Row className="align-items-center mt-3">
                    <Col xs={2}>
                      <strong>BANK</strong>
                    </Col>
                    <Col xs={2}>
                      <Form.Select
                        disabled
                        // onChange={handleBankChange}
                        value={selectedBank}
                      >
                        <option value="">Select Bank</option>
                        {loadingBanks ? (
                          <option>Loading...</option>
                        ) : errorBanks ? (
                          <option>{errorBanks}</option>
                        ) : (
                          bankList.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.bankname}
                            </option>
                          ))
                        )}
                      </Form.Select>
                    </Col>
                    {/* Branch Selection Dropdown */}
                    <Col xs={2}>
                      <Form.Select
                        // disabled={!selectedBank || loadingAccounts}
                        // onChange={handleAccountChange}
                        value={selectedAccount}
                        disabled
                      >
                        <option value="">
                          {loadingAccounts
                            ? "Loading..."
                            : errorAccounts
                            ? errorAccounts
                            : "Select Branch"}
                        </option>
                        {!loadingAccounts &&
                          !errorAccounts &&
                          accountList.map((account) => (
                            <option key={account.id} value={account.id}>
                              {account.bank_account} - {account.ifsc}
                            </option>
                          ))}
                      </Form.Select>
                    </Col>
                    <Col xs={4} className="d-flex">
                      <Form.Control
                        // disabled={!selectedBank && !bankAmount}
                        type="text"
                        value={bankAmount}
                        onChange={handleBankAmountChange}
                        placeholder="Enter bank amount"
                        disabled
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;
